// DOM utility functions
export function safeDomId(value) {
  return String(value ?? "").replace(/[^a-zA-Z0-9_-]/g, "_");
}
